import React from 'react';
import withAuth from "../../../../services/withAuth";
import Header from "../../../../components/Header";
import MembersApi from "../../../../services/portal-api/MembersApi";
import TextInput from "../../../../components/Form/components/TextInput";
import MobileTextInput from "../../../../components/Form/components/TextInput/MobileTextInput";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import SelectInput from "../../../../components/Form/components/SelectInput";
import CheckboxInput from "../../../../components/Form/components/CheckboxInput";
import { Redirect, Prompt } from "react-router-dom";
import PageTitle from "../../../../components/PageTitle";
import { COUNTRY_STATE_OPTIONS, COUNTRY_STATE_OPTIONS_NZ, COUNTRY_STATE_OPTIONS_AU } from "../../../../helpers/Constants";
import moment from "moment/moment";
import PostcodeTextInput from '../../../../components/Form/components/TextInput/PostcodeTextInput';
import EmailTextInput from '../../../../components/Form/components/TextInput/EmailTextInput';
import SuburbAutoComplete from '../../../../components/Form/components/AutoCompleteInput/SuburbAutoComplete';
import AuthService from "../../../../services/AuthService";
import GlobalsApi from "../../../../services/portal-api/GlobalsApi";
import NotFound from '../../../NotFound';

class EditMember extends React.Component {

    constructor(props) {
        super(props);

        // If there's a member from state, populate with that, otherwise we load
        let data = {
            firstName: '',
            lastName: '',
            email: '',
            noEmail: false,
            hiddenEmail: '',
            mobile: '',
            birthday: '',
            noBirthday: false,
            hiddenBirthday: '',
            suburb: '',
            postcode: '',
            countryState: '',
            rewardsExpiryDate: '',
            country: '',
        };

        let member = null;

        if (typeof props.history.location.state !== 'undefined' && typeof props.history.location.state.member !== 'undefined') {
            member = props.history.location.state.member;
            data = this.getFormData(member);

            COUNTRY_STATE_OPTIONS_NZ.forEach((i, j) => {
                if (i.value === member.state) {
                    data.country = "globals_nz";
                }
            });

            COUNTRY_STATE_OPTIONS_AU.forEach((i, j) => {
                if (i.value === member.state) {
                    data.country = "globals_au";
                }
            });

            if (data.country === undefined) {
                data.country = "globals_" + sessionStorage.getItem('site').toLowerCase();
            }
        } else {
            const memberId = this.props.match.params.id;
            this.getMemberCallId = MembersApi.getMember(memberId, (result, callId) => {
                // console.log(result);
                if (callId !== this.getMemberCallId) {
                    return;
                }

                this.setState({
                    isLoadingMember: false,
                    member: result.json.member,
                    data: this.getFormData(result.json.member),
                });

                COUNTRY_STATE_OPTIONS_NZ.forEach((i, j) => {
                    if (i.value === result.json.member.state) {
                        this.setState({ data: { ...this.state.data, country: "globals_nz" } });
                    }
                });

                COUNTRY_STATE_OPTIONS_AU.forEach((i, j) => {
                    if (i.value === result.json.member.state) {
                        this.setState({ data: { ...this.state.data, country: "globals_au" } });
                    }
                });

                // if (data.country === undefined) {
                //     data.country = "globals_" + sessionStorage.getItem('site').toLowerCase();
                // }

            });

        }

        //console.log("hi ", data);

        this.state = {
            isLoadingMember: false,
            isEdited: false,
            member: member,
            isLoadingForm: false,
            data: data,
            errors: {},
            viewSlug: null,
            stringSuburbs: '',
        };

        this.handleSuburbSelected = this.handleSuburbSelected.bind(this);
        this.stringSuburbs = '';
    }


    componentDidMount() {

        document.title = 'Editing Member - duskPortal';
        document.body.className = 'page--blue';
        $('input:first').focus();


        if (this.state.member !== null) {
            document.title = 'Editing ' + this.state.member.firstName + ' ' + this.state.member.surname + ' - duskPortal';
            return;
        }



        this.setState({
            isLoadingMember: true,
        });

        // this.getMemberCallId = MembersApi.getMember(this.props.match.params.id, (result, callId) => {

        //     // Check if we're still interested in this response
        //     if (callId !== this.getMemberCallId) {
        //         return;
        //     }


        //     if (result.success) {
        //         this.setState({
        //             isLoadingMember: false,
        //             member: result.json.member,
        //             data: this.getFormData(result.json.member),
        //         });
        //         // TODO: find a better way
        //         setTimeout(function () { $('.select').customSelect(); }, 50);
        //     }
        //     else {

        //         // Check for auth
        //         if (result.status === 401) {
        //             this.props.sessionExpired();
        //             this.setState({
        //                 isLoadingMember: false,
        //             });
        //             return;
        //         }

        //         this.setState({
        //             isLoadingMember: false,
        //             // TODO: handle error
        //             //memberError: result.json.error
        //         });
        //     }
        // });
    }


    getFormData = (member) => {

        const data = {};
        data.firstName = member.firstName;
        data.lastName = member.surname;
        data.email = member.email;
        data.noEmail = (member.email === '');
        data.hiddenEmail = '';
        data.mobile = member.mobile;
        data.birthday = '';
        if (member.birthdate !== '') {
            data.birthday = moment(member.birthdate).format('DD/MM/YYYY');
        }
        data.noBirthday = (member.birthdate === '');
        data.hiddenBirthday = '';
        data.suburb = member.suburb;
        data.postcode = member.postcode;
        data.countryState = member.countryState;
        // Admin only
        if ((AuthService.isAdmin() || AuthService.getAdminType() == 3) && member.rewardsExpiryDate !== '') {
            data.rewardsExpiryDate = member.firstName != "Deleted" ? moment(member.rewardsExpiryDate).format('DD/MM/YYYY') : "";
        }

        return data;

    };

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[event.target.name];
        const data = this.state.data;

        if (name == "countryOveride") {
            data['country'] = event.target.value;
            data['countryState'] = '';
            data['suburb'] = '';
            data['postcode'] = '';
        } else {
            data[event.target.name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        }

        if (name === 'mobile' && data['country']) {
            const countryCode = data['country'];
            const mobileNumber = event.target.value.trim();
    
            // AU validation
            if (countryCode === "globals_au") {
                if (!mobileNumber.startsWith("04") || mobileNumber.length !== 10) {
                    errors.mobile = "Mobile number needs to start with 04 and must be 10 digits long";
                }
            }
    
            // NZ validation
            if (countryCode === "globals_nz") {
                if (!mobileNumber.startsWith("02") || mobileNumber.length < 9 || mobileNumber.length > 11) {
                    errors.mobile = "Mobile number needs to start with 02 and must be between 9 to 11 digits long";
                }
            }

            console.log("mobileNumber length: ", mobileNumber.length);
            if (mobileNumber.length == 0) {
                delete errors.mobile;
            }
        }

        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
        }, () => { 
            console.log(this.state) 
        });
    };

    onBirthdayBlur = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;
        let val = event.target.value;
        let j = moment().format('YYYY-MM-DD HH:mm:ss');
        let k = moment(val.toString(), 'DD/MM/YYYY', true).format('YYYY-MM-DD HH:mm:ss');

        if (moment(val, 'DD/MM/YYYY', true).isValid() == false) {
            errors[name] = "Date must be in DD/MM/YYYY format. Please try again";
        } else if (moment(j).diff(moment(k), 'years') > window.maxAge) {
            errors[name] = "Birthday must not be older than " + window.maxAge + " years";
        }

        if (moment(val, 'DD/MM/YYYY', true).isAfter()) {
            errors[name] = "Birthday must not be in the future";
        }

        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
        });

    }

    _toggleNoEmail = (event) => {
        const noEmail = event.target.checked;
        const data = this.state.data;
        const errors = this.state.errors;
        if (noEmail) {
            // Store value
            data['hiddenEmail'] = data['email'];
            // Clear value
            delete errors['email'];
            data['email'] = '';
        }
        else {
            // Restore hidden value
            data['email'] = data['hiddenEmail'];
        }
        this.setState({ data: data, errors: errors });
        this.handleInput(event);
    };

    _toggleNoBirthday = (event) => {
        const noBirthday = event.target.checked;
        const data = this.state.data;
        const errors = this.state.errors;
        if (noBirthday) {
            // Store value
            data['hiddenBirthday'] = data['birthday'];
            // Clear value
            delete errors['birthday'];
            data['birthday'] = '';
        }
        else {
            // Restore hidden value
            data['birthday'] = data['hiddenBirthday'];
        }
        this.setState({ data: data, errors: errors });
        this.handleInput(event);
    };

    handleSuburbSelected(suburb) {
        const { data } = this.state;
        data['suburb'] = suburb.suburb;
        data['postcode'] = suburb.postcode;
        data['countryState'] = suburb.state.toLowerCase();

        this.setState({
            data: data,
        });
    }

    handleSubmit = (event) => {

        // Prevent default behaviour
        event.preventDefault();

        const errors = this.state.errors;

        if (errors.hasOwnProperty('mobile')) {
            return false;
        }
        
        // Show loading and reset state
        this.setState({
            isLoadingForm: true,
            errors: {},
        });

        // Fetch data
        this.newMemberCallId = MembersApi.updateMember(this.props.match.params.id, this.state.data, (response, callId) => {

            // Check if we're still interesting in this response
            if (callId !== this.newMemberCallId) {
                return;
            }

            // Check for errors
            if (response.success) {

                // Redirect away
                this.setState({
                    isLoadingForm: false,
                    isEdited: false,
                    viewSlug: response.json.slug,
                });
            }
            else {
                // Check for auth
                if (response.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoadingForm: false,
                    });
                    return;
                }

                if (response.json.errors) {
                    this.setState({
                        isLoadingForm: false,
                        errors: response.json.errors,
                    });
                }
                else if (response.json.error) {
                    this.setState({
                        isLoadingForm: false,
                        errors: { error: response.json.error },
                    });
                }
                else {
                    this.setState({
                        isLoadingForm: false,
                    });
                }
            }
        });
    };

    render() {
        if (sessionStorage.getItem("globals_nz") == null || sessionStorage.getItem("globals_nz") == 'undefined' || sessionStorage.getItem("globals_nz") == "") {
            GlobalsApi.getSuburbs('NZ', (result, callId) => {
                sessionStorage.setItem("globals_nz", JSON.stringify(result.json));
                // this.stringSuburbs = JSON.stringify(result.json);
                this.setState({
                    stringSuburbs: JSON.stringify(result.json)
                }, () => {
                    console.log("New Zealand: ", this.state.stringSuburbs);
                })
                // this.forceUpdate();
            });
        }

        if (sessionStorage.getItem("globals_au") == null || sessionStorage.getItem("globals_au") == 'undefined' || sessionStorage.getItem("globals_au") == "") {
            GlobalsApi.getSuburbs('AU', (result, callId) => {
                sessionStorage.setItem("globals_au", JSON.stringify(result.json));
                // this.stringSuburbs = JSON.stringify(result.json);
                // this.forceUpdate();
                this.setState({
                    stringSuburbs: JSON.stringify(result.json)
                }, () => {
                    console.log("Australia: ", this.state.stringSuburbs);
                })
            });
        }

        const viewUrl = this.props.history.location.pathname.replace('/edit', '');
        if (this.state.viewSlug) {
            return (<Redirect to={viewUrl} />);
        }

        const member = this.state.member;

        let pageTitle = 'Finding member...';
        if (member !== null) {
            pageTitle = 'Editing ' + member.firstName + ' ' + member.surname;
        }

        let emailWarning = null;
        if (this.state.data.noEmail) {
            emailWarning = 'Member cannot receive promotion vouchers.';
        }
        let birthdayWarning = null;
        if (this.state.data.noBirthday) {
            birthdayWarning = 'Member cannot receive Birthday promotion.';
        }

        // let countryOptions = null;
        // if (!this.state.data.country) {
        //     countryOptions = [];
        // } else {
        //     if (this.state.data.country == "globals_nz")
        //         countryOptions = COUNTRY_STATE_OPTIONS_NZ;
        //     if (this.state.data.country == "globals_au")
        //         countryOptions = COUNTRY_STATE_OPTIONS_AU;
        // }

        let countryOptions = [];
        if (this.state.data.country === 'globals_nz') {
            countryOptions = COUNTRY_STATE_OPTIONS_NZ;
        } else if (this.state.data.country === 'globals_au') {
            countryOptions = COUNTRY_STATE_OPTIONS_AU;

        }

        let countryOveride = [{ key: "globals_au", value: "Australia" }, { key: "globals_nz", value: "New Zealand" }];


        return (
            AuthService.can('Edit member') ?
                <div>
                    <Prompt when={this.state.isEdited} message="You have unsaved changes that will be lost. Are you sure you want to leave this page?" />
                    <Header />
                    <main className="content" role="main">
                        <div className="container padding--60">

                            <header className="header--page clearfix">

                                <PageTitle back={viewUrl} title={pageTitle} />

                            </header>

                            <LoadingSpinner isVisible={this.state.isLoadingMember} />

                            {member !== null && !member.isPending && member.isPendingUpdate && <div className="alert alert--outline alert--success margin--40--top">

                                {!AuthService.isAdmin() && <span>This member was recently updated and we are still currently processing the request. The updated details are populated below.</span>}
                                {AuthService.isAdmin() && <span>This member was recently updated and we are currently still processing the request. The updated details are populated below.</span>}

                            </div>}

                            {this.state.errors.error && <div className="alert alert--outline alert--error margin--40--top">
                                <span>Unable to update member: {this.state.errors.error} Please try again, or contact Loyalty Support if the problem persists.</span>
                            </div>}

                            {member !== null && <form onSubmit={this.handleSubmit} className="margin--40--top validate loading--inline padding--200--bot">

                                <div className="col-2 gutter--40">

                                    <div className="col">
                                        <TextInput
                                            name="firstName"
                                            label="First Name"
                                            value={this.state.data.firstName}
                                            error={this.state.errors.firstName}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                    <div className="col">
                                        <TextInput
                                            name="lastName"
                                            label="Last Name"
                                            value={this.state.data.lastName}
                                            error={this.state.errors.lastName}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                    <div className="col">
                                        <EmailTextInput
                                            name="email"
                                            label="Email Address"
                                            value={this.state.data.email}
                                            error={this.state.errors.email}
                                            warning={emailWarning}
                                            onChange={this.handleInput}
                                            type="email"
                                            required={!this.state.data.noEmail}
                                            disabled={this.state.data.noEmail}
                                        />
                                        <CheckboxInput
                                            name="noEmail"
                                            label="No Email Address"
                                            isChecked={this.state.data.noEmail}
                                            onChange={this._toggleNoEmail}
                                        />
                                    </div>
                                    <div className="col">
                                        <div className="col-2 gutter--40">
                                            <div className="col">
                                                <div className="col">
                                                    <MobileTextInput
                                                        name="mobile"
                                                        label="Mobile Number (Optional)"
                                                        value={this.state.data.mobile}
                                                        error={this.state.errors.mobile}
                                                        onChange={this.handleInput}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col">
                                                <TextInput
                                                    name="birthday"
                                                    label="Birthdate"
                                                    placeholder={(!this.state.data.noBirthday) ? 'DD/MM/YYYY' : ''}
                                                    value={this.state.data.birthday}
                                                    error={this.state.errors.birthday}
                                                    warning={birthdayWarning}
                                                    onBlur={this.onBirthdayBlur}
                                                    onChange={this.handleInput}
                                                    required={!this.state.data.noBirthday}
                                                    disabled={this.state.data.noBirthday}
                                                />
                                                <CheckboxInput
                                                    name="noBirthday"
                                                    label="No Birthdate"
                                                    isChecked={this.state.data.noBirthday}
                                                    onChange={this._toggleNoBirthday}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="col-3 gutter--15 suburb-state-postcode">
                                            <div className="col">
                                                <SuburbAutoComplete
                                                    name="suburb"
                                                    label="Suburb (Optional)"
                                                    value={this.state.data.suburb}
                                                    error={this.state.errors.suburb}
                                                    onChange={this.handleInput}
                                                    onSuburbSelected={this.handleSuburbSelected}
                                                    country={this.state.data.country}
                                                    extras={this.state.stringSuburbs}
                                                />
                                            </div>
                                            <div className="col">
                                                <SelectInput
                                                    name="countryState"
                                                    label="State / Country"
                                                    options={countryOptions}
                                                    value={this.state.data.countryState}
                                                    error={this.state.errors.countryState}
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                            <div className="col">
                                                <PostcodeTextInput
                                                    name="postcode"
                                                    label="Postcode"
                                                    value={this.state.data.postcode}
                                                    error={this.state.errors.postcode}
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="col-2 gutter--40">
                                            {AuthService.can('expiry date') &&
                                                <div className="col">
                                                    <TextInput
                                                        name="rewardsExpiryDate"
                                                        label="Expiry Date (Admin only)"
                                                        placeholder="DD/MM/YYYY"
                                                        value={this.state.data.rewardsExpiryDate}
                                                        error={this.state.errors.rewardsExpiryDate}
                                                        onChange={this.handleInput}
                                                    />
                                                </div>
                                            }
                                            {/* {(AuthService.isAdmin() || AuthService.getAdminType() == 3) &&  */}
                                            {AuthService.can('change country') &&
                                                <div className="col">
                                                    <SelectInput
                                                        name="countryOveride"
                                                        label="Change country (Admin only)"
                                                        options={countryOveride}
                                                        value={this.state.data.country}
                                                        onChange={this.handleInput}
                                                        disabled={false}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>

                                </div>
                                <footer className="footer--form clearfix">
                                    <div className="footer--form__left">
                                    </div>
                                    <div className="footer--form__right">
                                        <button type="submit" className="btn btn--large btn--color">Save</button>
                                    </div>
                                </footer>
                                <LoadingSpinner isVisible={this.state.isLoadingForm} />
                            </form>}

                        </div>
                    </main>
                </div>
                : <NotFound forbidden={true} />
        );
    }
}

export default withAuth(EditMember);
